import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["backButton", "children"];
import PropTypes from 'prop-types';
import React, { cloneElement, forwardRef } from 'react';
import { IconChevronLeft } from '../Icon/index';
import { StyledPageBreadcrumb } from './PageBreadcrumb.styles';

/**
 * The page breadcrumb is used for navigational elements preceding the page title.
 *
 * @extends PageContent
 * @since 8.15.0
 */
export var PageBreadcrumb = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var backButton = _ref.backButton,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var backButtonClone = backButton && /*#__PURE__*/cloneElement(backButton, {
    icon: /*#__PURE__*/React.createElement(IconChevronLeft, null)
  });
  return /*#__PURE__*/React.createElement(StyledPageBreadcrumb, _extends({
    ref: forwardedRef
  }, rest), backButtonClone, children);
});
PageBreadcrumb.displayName = 'PageBreadcrumb';
PageBreadcrumb.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `TextButton` that will be augmented with a back icon.
   */
  backButton: PropTypes.node.isRequired,
  /**
   * Children content will be placed directly into the breadcrumb row.
   */
  children: PropTypes.node
} : {};